import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { ActivatedRoute, Router } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { map } from 'rxjs';

import { AppState } from '@tsq-web/state';

import { getEnvironment } from '../../../shared/environment';
import { CommunitiesEnvironments } from '../../../shared/environment/models/communities-environments.enum';
import * as fromNeighborMassInviteActions from '../../state/neighbor-mass-invite.actions';
import * as fromNeighborMassInviteState from '../../state/neighbor-mass-invite.selectors';

@Component({
  template: `
    <img [src]="logoUrl" class="h-40" alt="" />

    <div
      [ngSwitch]="invitationStep$ | async"
      class="border-1 border-petro-n2 mt-48 w-[504px] rounded-2xl bg-white px-40 pb-48 pt-32"
    >
      <comm-neighbor-mass-invite-emails-input-card
        *ngSwitchCase="'sending'"
        class="font-base"
        [isSending]="isSending$ | async"
        (sendInvites)="sendInvites($event)"
        (goBack)="goBackToCommunity()"
      />
      <comm-neighbor-mass-invite-invites-sent-card
        *ngSwitchCase="'sent'"
        class="font-base"
        (goToCommunity)="goBackToCommunity()"
        (goBack)="restoreState()"
      />
    </div>

    <comm-in-app-feedback-modal />
  `,
  styles: [
    `
      :host {
        @apply py-120 bg-petro-n1 block flex min-h-screen flex-col items-center px-24;
      }
    `,
  ],
})
export class MainNeighborMassInviteV2Component implements OnInit, OnDestroy {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly analytics = inject(AngularFireAnalytics);

  protected readonly isSending$ = this.store.pipe(
    select(fromNeighborMassInviteState.selectIsLoading),
  );
  protected readonly isSuccessful$ = this.store.pipe(
    select(fromNeighborMassInviteState.selectIsSuccessful),
  );
  protected readonly invitationStep$ = this.isSuccessful$.pipe(
    map(isSuccessful => (isSuccessful ? 'sent' : 'sending')),
  );

  protected readonly logoUrl =
    getEnvironment().env === CommunitiesEnvironments.BR_PROD
      ? '/assets/brand/logo.svg'
      : '/assets/brand/logo-community.svg';

  ngOnInit(): void {
    this.analytics.logEvent('invites_bulk_form');
  }

  ngOnDestroy(): void {
    this.store.dispatch(new fromNeighborMassInviteActions.RestoreNeighborMassInviteState());
  }

  sendInvites(emails: string[]): void {
    this.analytics.logEvent('invites_bulk_submit');
    this.store.dispatch(new fromNeighborMassInviteActions.SendInvitesRequest({ emails }));
  }

  goBackToCommunity(): void {
    this.router.navigate([
      'w',
      this.activatedRoute.snapshot.params.condoId,
      'residents',
      'invites',
    ]);
  }

  restoreState(): void {
    this.store.dispatch(new fromNeighborMassInviteActions.RestoreNeighborMassInviteState());
  }
}
